var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120.2 125.4",
    enableBackground: "new 0 0 120.2 125.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#72B654",
    d: "M112.2,46.2C105.4,23,82.5,5.3,57.7,8.4c-0.1-0.2-0.3-0.2-0.6-0.2C34.5,10.7,16.3,27.2,9.6,48.6 c-0.8,2.7-1.5,5.4-2,8.2c-0.2,0.1-0.2,0.4-0.1,0.5c-0.2,1-0.3,2-0.4,3c-0.1,0.1-0.1,0.2,0,0.3C6.3,68,6.8,75.4,8.9,82.4 c0.9,2.9,2,5.6,3.5,8c0,0.2,0.1,0.4,0.3,0.5c3.9,6.5,9.5,11.7,16.1,15.9c9.8,6.3,20.6,10.6,32.4,10.4c1.3,0,2.6-0.1,3.9-0.2 c0.2,0.2,0.7,0.2,0.8-0.1c8.9-0.9,17.7-4.1,25.2-8.9c9.8-6.3,16.9-14.7,20.4-25.8C115.1,70.6,115.6,57.9,112.2,46.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.6078,
    y1: 72.2413,
    x2: 114.4994,
    y2: 72.2413
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    style: {
      stopColor: "#365625"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3926,
    style: {
      stopColor: "#4C7534"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    style: {
      stopColor: "#72A851"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8992,
    style: {
      stopColor: "#84BF5F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M113.1,51.8L69.2,32.6L43.6,89.3l2.9,6.3l37.6,16.3c2.4-1.1,4.7-2.3,7-3.7c9.8-6.1,16.9-14.2,20.4-25 C114.8,73.1,115.5,62.2,113.1,51.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M48.7,52.8c-2,0.7-4.3,0.6-6.3-0.1c-2.5-0.9-4.7-2.7-6.3-4.8l2.3-1.1c-0.6-0.9-1.3-1.7-1.9-2.6c-0.2-0.3-0.7-1.5-0.8-1.9 c-0.3-1.1,1-1.4,2.1-1.7s2.4,0.1,3.5,0.5c0.4-1.5,0.7-2.9,1.1-4.4c0.1-0.4,0.2-0.8,0.6-0.9c0.3-0.1,0.7,0.1,0.9,0.3 c1.3,0.9,2.6,2,3.6,3.2c0.5-0.5,1-0.9,1.5-1.4l3.1-1.2c-0.2-1-0.4-2.1-0.6-3.1c-0.1-0.4,0-1.7,0-2c0.2-1.2,1.5-0.9,2.6-0.6 s2.1,1.1,3,1.9c0.9-1.2,1.9-2.4,2.8-3.6c0.2-0.3,0.6-0.6,0.9-0.6c0.3,0,0.6,0.3,0.7,0.6c0.9,1.4,1.5,2.8,2,4.4 c1.3-0.4,2.6-0.9,3.9-1.3c0.3-0.1,0.7-0.2,1.1-0.1c0.6,0.2,0.7,1.1,0.7,1.7l1,1.9c0.8,1.1,1.7,2.1,2.5,3.2c1.2-1,2.6-1.9,4.1-2.6 c0.3-0.1,0.7-0.3,1-0.1c0.3,0.2,0.4,0.6,0.5,1c0.1,1.5,0.3,3,0.4,4.5c1.2-0.2,2.4-0.4,3.5,0.1c1.1,0.4,2.3,0.9,1.8,2 c-0.2,0.3-0.8,1.5-1.1,1.7c-0.8,0.8-1.5,1.5-2.3,2.3l2.1,1.5c-1.9,1.9-4.4,3.3-7,3.8c-1.5,0.3-3,0.2-4.4-0.2L71,54.2l4.6,33.9 c-0.7,6-6.5,5.9-6.5,5.9c-1,0.1-1.9,0-2.6-0.1l-0.6,0.2c-0.8,1.6-2.6,3.1-6.1,3.1c0,0-3.8,0.3-5.8-3.1L53,94 c-0.7,0.1-1.5,0.2-2.5,0.1c0,0-5.8,0-6.5-5.9l4.7-34.6L48.7,52.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M58.6,49.6c0,0-4.4,45.1-0.9,45.4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M51.8,54.5c0,0-5.9,35.3-3.5,36.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M68.5,54.5c0,0,5.9,35.3,3.5,36.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M69.2,36.4c0.7,1,1.6,1.9,2.3,2.9c1.1-0.9,2.4-1.8,3.8-2.4c0.3-0.1,0.6-0.3,0.9-0.1c0.3,0.2,0.4,0.6,0.5,0.9 c0.1,1.4,0.3,2.8,0.4,4.1c1.1-0.2,2.2-0.4,3.2,0.1c1,0.4,2.1,0.8,1.7,1.8c-0.2,0.3-0.7,1.4-1,1.6c-0.7,0.7-1.4,1.4-2.1,2.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M80.7,48.9c-1.8,1.8-4.1,3-6.4,3.5c-2.5,0.5-5.2-0.1-7-1.8c-0.9-0.8-1.7-1.8-2.3-2.9c-0.3-0.4-0.5-0.8-0.7-1.2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M49.8,38.2c-0.5,0.5-0.9,0.8-1.4,1.3c-1-1.1-2.1-2.1-3.3-2.9c-0.3-0.2-0.6-0.4-0.8-0.3c-0.4,0.1-0.5,0.6-0.6,0.8 c-0.4,1.4-0.6,2.7-1,4.1c-1-0.4-2.1-0.7-3.2-0.5s-2.3,0.6-2,1.7c0.1,0.4,0.6,1.5,0.7,1.8c0.6,0.8,1.2,1.6,1.8,2.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M37.9,47.6c1.5,1.9,3.5,3.7,5.8,4.4c2.3,0.8,5.1,0.7,7.2-0.6c1.1-0.6,1.9-1.6,2.8-2.6c0.6-0.6,1-1.3,1.5-2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#72B654",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M50.3,37.2c0.6,2.4,1.7,4.8,3.4,6.4c1.8,1.8,4.3,2.8,6.8,2.5c1.3-0.2,2.4-0.6,3.6-1.2c1.2-0.6,2.4-1.2,3.3-2.1 c1-0.9,1.8-2.1,1.8-3.4c0-0.3,0-0.6-0.1-0.7c-0.5-0.5-1.5,0.1-1.8-0.5c0.5-1.2,0.8-2.5,0.9-3.8c0.1-0.6,0-1.4-0.6-1.6 c-0.3-0.1-0.6,0-1,0.1c-1.2,0.4-2.4,0.8-3.6,1.2c-0.5-1.4-1-2.8-1.8-4.1c-0.2-0.3-0.4-0.6-0.6-0.6c-0.4,0-0.6,0.3-0.8,0.6 c-0.8,1.1-1.8,2.2-2.6,3.3c-0.8-0.7-1.7-1.5-2.8-1.8c-1.1-0.3-2.3-0.5-2.4,0.6c-0.1,0.4-0.1,1.6,0,1.8c0.2,0.9,0.4,1.9,0.6,2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeleryIcon);
export default __webpack_public_path__ + "static/media/celery_icon.21e3564c31d092e20583aa191452aafb.svg";
export { ForwardRef as ReactComponent };